import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import STYLES from './PriceMarkerV2.module.scss';

type Props = {
  price: string;
  locationId: string;
  onLocationClicked: (key: string) => void;
};

const PriceMarkerV2 = ({ locationId, onLocationClicked, price }: Props) => {
  const onMarkerClick = () => onLocationClicked(locationId);

  return (
    <div
      className={STYLES.PriceMarkerV2__marker}
      onClick={onMarkerClick}
      onKeyDown={onMarkerClick}
      onMouseDown={(e) => e.preventDefault()}
      role="button"
      tabIndex={0}
    >
      <BpkText textStyle={TEXT_STYLES.label3} tagName="span">
        {price}
      </BpkText>
    </div>
  );
};

export default PriceMarkerV2;
